export default __webpack_public_path__ + "static/media/noinvoices.2929495d.svg";